(function () {
  var STEPS = [
    '¡Pedido recibido!',
    'Estamos preparándolo',
    'Ya fue enviado',
    'Está en camino',
    'Entregado',
  ];

  function normalizeOrderName(raw) {
    var s = String(raw || '').trim();
    if (!s) return '';
    // Confirmation # (letras+números) — no forzar prefijo #
    if (/^[A-Za-z0-9]{8,}$/.test(s) && !/^\d+$/.test(s)) return s;
    return s.charAt(0) === '#' ? s : '#' + s;
  }

  function stepIndex(estado) {
    var normalized = coerceEstado(estado);
    var i = STEPS.indexOf(normalized);
    return i >= 0 ? i : 0;
  }

  /** Soporta single_line y list.single_line (Shopify a veces guarda lista). */
  function coerceEstado(raw) {
    if (Array.isArray(raw)) {
      return String(raw[0] || STEPS[0]).trim() || STEPS[0];
    }
    var s = String(raw == null ? '' : raw).trim();
    if (!s) return STEPS[0];
    if (s.charAt(0) === '[') {
      try {
        var parsed = JSON.parse(s);
        if (Array.isArray(parsed)) return String(parsed[0] || STEPS[0]).trim() || STEPS[0];
      } catch (e) {
        /* ignore */
      }
    }
    return s;
  }

  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso + 'T12:00:00');
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleDateString('es-MX', { day: 'numeric', month: 'long', year: 'numeric' });
  }

  function renderProgress(root, activeIndex) {
    var track = root.querySelector('[data-oleum-tracking-steps]');
    if (!track) return;
    track.innerHTML = '';

    var iconDone = root.getAttribute('data-icon-done') || '';
    var iconPending = root.getAttribute('data-icon-pending') || '';

    STEPS.forEach(function (label, i) {
      var isDone = i <= activeIndex;
      var iconSrc = isDone ? iconDone : iconPending;
      var step = document.createElement('div');
      step.className = 'oleum-order-tracking__step' + (isDone ? ' is-done' : ' is-pending');
      step.setAttribute('role', 'listitem');
      step.innerHTML =
        '<span class="oleum-order-tracking__step-icon" aria-hidden="true">' +
        (iconSrc
          ? '<img src="' +
            iconSrc +
            '" alt="" width="40" height="40" loading="lazy" decoding="async">'
          : '') +
        '</span>' +
        '<span class="oleum-order-tracking__step-label">' +
        label +
        '</span>';

      track.appendChild(step);

      if (i < STEPS.length - 1) {
        var arrow = document.createElement('span');
        arrow.className = 'oleum-order-tracking__arrow' + (i < activeIndex ? ' is-done' : '');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '›';
        track.appendChild(arrow);
      }
    });
  }

  function showResult(root, data) {
    var panel = root.querySelector('[data-oleum-tracking-result]');
    var err = root.querySelector('[data-oleum-tracking-error]');
    if (err) {
      err.hidden = true;
      err.textContent = '';
    }
    if (!panel) return;

    var idx = stepIndex(data.estado);
    renderProgress(root, idx);

    var statusEl = root.querySelector('[data-oleum-tracking-status]');
    var dateEl = root.querySelector('[data-oleum-tracking-date]');
    if (statusEl) statusEl.textContent = coerceEstado(data.estado) || STEPS[0];
    if (dateEl) {
      if (data.envioEstimado) {
        dateEl.textContent = formatDate(data.envioEstimado);
        dateEl.closest('[data-oleum-tracking-date-wrap]').hidden = false;
      } else {
        dateEl.closest('[data-oleum-tracking-date-wrap]').hidden = true;
      }
    }

    panel.hidden = false;
  }

  function showError(root, message) {
    var panel = root.querySelector('[data-oleum-tracking-result]');
    var err = root.querySelector('[data-oleum-tracking-error]');
    if (panel) panel.hidden = true;
    if (err) {
      err.hidden = false;
      err.textContent = message;
    }
  }

  function lookupLocal(root, orderName, email) {
    var el = root.querySelector('[data-oleum-customer-orders]');
    if (!el) return null;
    try {
      var orders = JSON.parse(el.textContent || '[]');
      var name = normalizeOrderName(orderName);
      var mail = String(email || '').trim().toLowerCase();
      for (var i = 0; i < orders.length; i++) {
        var o = orders[i];
        if (normalizeOrderName(o.name) === name && String(o.email || '').toLowerCase() === mail) {
          return o;
        }
      }
    } catch (e) {
      /* ignore */
    }
    return null;
  }

  async function lookupProxy(endpoint, orderName, email) {
    var url = endpoint.replace(/\/$/, '');
    var res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ orderName: normalizeOrderName(orderName), email: String(email || '').trim() }),
    });
    var json = await res.json().catch(function () {
      return { ok: false, error: 'Respuesta inválida del servidor.' };
    });
    if (!json.ok) throw new Error(json.error || 'No se encontró el pedido.');
    return json;
  }

  function init(root) {
    if (!root || root.dataset.oleumTrackingInit === '1') return;
    root.dataset.oleumTrackingInit = '1';

    var form = root.querySelector('[data-oleum-tracking-form]');
    if (!form) return;

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var orderInput = form.querySelector('[name="order_name"]');
      var emailInput = form.querySelector('[name="email"]');
      var btn = form.querySelector('[type="submit"]');
      var orderName = orderInput && orderInput.value;
      var email = emailInput && emailInput.value;
      var endpoint = root.dataset.proxyEndpoint || '';

      if (btn) btn.disabled = true;

      try {
        var data = lookupLocal(root, orderName, email);
        if (!data && endpoint) {
          data = await lookupProxy(endpoint, orderName, email);
        }
        if (!data) {
          showError(
            root,
            'No encontramos ese pedido. Revisa el número y el correo de la compra.'
          );
          return;
        }
        showResult(root, data);
      } catch (e) {
        showError(root, e.message || 'Error al consultar el pedido.');
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  }

  document.querySelectorAll('[data-oleum-order-tracking]').forEach(init);
  document.addEventListener('shopify:section:load', function (ev) {
    var root = ev.target && ev.target.querySelector('[data-oleum-order-tracking]');
    if (root) init(root);
  });
})();
